import { motion } from 'framer-motion';
import { BookOpen, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const CatalogueFlipbookBanner = ({ 
  className = "" 
}) => {
  return (
    <section className={`bg-stone-50 border-b border-stone-200 ${className}`} data-testid="catalogue-flipbook-banner">
      <div className="container-portico py-7 md:py-9">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.4 }}
          className="flex flex-col md:flex-row items-center justify-between gap-5 md:gap-8"
        >
          {/* Text */}
          <div className="text-center md:text-left">
            <h2 className="text-base md:text-lg font-heading font-semibold text-stone-800 mb-1">
              Explore Our Full Product Catalogue
            </h2>
            <p className="text-sm text-stone-500">
              Browse our complete flooring collection in an interactive flipbook.
            </p>
          </div>

          {/* CTA */}
          <Link
            to="/catalogue"
            className="flex-shrink-0"
            data-testid="catalogue-flipbook-cta"
          >
            <Button
              size="lg"
              className="group gap-2.5 px-7 rounded-full text-sm font-semibold shadow-sm hover:shadow-md transition-all duration-200"
            >
              <BookOpen className="w-4 h-4" />
              View Catalogue
              <ArrowRight className="w-3.5 h-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default CatalogueFlipbookBanner;
